import { useState, useMemo } from 'react';
import { DateRange } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { paymentsActions } from 'store/actions';
import { downloadCSV } from './exportCSV';
import { RadioBox, Buttons } from 'components';
import { DownloadIcon } from 'assets/icons';
import { TransactionsTable } from './table/TransactionsTable';
import { paymentsAPI } from 'services/payments.service.js';

import * as S from './TransactionsSection.styled';

function formatDate(string) {
  return string.replaceAll('/', '-');
}

export const TransactionsSection = () => {
  const timePeriod = useSelector((state) => state?.payments?.timePeriod);
  const dateRangeName = useSelector((state) => state?.payments?.rangeName);
  const [filter, setFilter] = useState('all');
  const dispatch = useDispatch();

  const { data, isFetching, isError } = paymentsAPI.useGetPublisherTransactionsQuery({
    to: formatDate(timePeriod.to),
    from: formatDate(timePeriod.from),
  });

  const filteredData = useMemo(() => {
    return data?.filter((item) => {
      if (filter === 'all') return true;
      if (filter === 'charge') return item.paymentType === 'Charge';
      if (filter === 'credit') return item.paymentType === 'Credit';
    });
  }, [isFetching, filter, timePeriod.from, timePeriod.to]);

  function updateRangeName(rangeName) {
    dispatch(paymentsActions.updateDateRangeName(rangeName));
  }

  function updateTimeRange(fromDate, toDate) {
    dispatch(paymentsActions.updateTimeRange({ from: fromDate, to: toDate }));
  }

  const filename = `Transactions for ${formatDate(timePeriod.from)} to ${formatDate(
    timePeriod.to,
  )}.csv`;

  return (
    <>
      <S.Heading>Transactions History</S.Heading>
      <S.Box>
        <DateRange
          dateFrom={timePeriod.from}
          dateTo={timePeriod.to}
          dateRangeName={dateRangeName}
          onUpdateRangeName={updateRangeName}
          onUpdateTimeRange={updateTimeRange}
        />
        <S.ButtonsBox>
          <RadioBox.NormalSize
            label='All'
            width={64}
            variant='left'
            onChange={() => setFilter('all')}
            pressed={filter === 'all'}
            value={'all'}
          />
          <RadioBox.NormalSize
            label='Charge'
            width={93}
            variant='center'
            onChange={() => setFilter('charge')}
            pressed={filter === 'charge'}
            value={'charge'}
          />
          <RadioBox.NormalSize
            label='Credit'
            width={86}
            variant='right'
            onChange={() => setFilter('credit')}
            pressed={filter === 'credit'}
            value={'credit'}
          />
        </S.ButtonsBox>
        <Buttons.TertiaryNormal
          icon={<DownloadIcon style={{ color: '#64748B' }} />}
          style={{ marginLeft: 'auto', color: '#334155', fontWeight: '500' }}
          isDisabled={isFetching || isError || !data?.length}
          onClick={() => downloadCSV(filteredData, filename)}
        >
          Export .CSV
        </Buttons.TertiaryNormal>
      </S.Box>
      <TransactionsTable filteredData={filteredData} />
    </>
  );
};
